export const returns = {
  orderCancellation: {
    breadcrumb: {
      service: 'Advice & Service',
      cancellation: 'Returns & Order Cancellation',
    },
    page: {
      title: 'Return or Cancellation of Your Order',
      introText1:
        'You can initiate a return or cancellation for your order via the form below. This option is available for both registered customers and guest orders.',
    },
    form: {
      orderNumber: 'Order number',
      orderNumberError: 'Please enter your order number.',
      customerNumber: 'Customer number',
      submit: 'VIEW ORDER',
    },
    cancelOrder: {
      title: 'Cancel or return items',
      notFoundError: 'The order number or customer number entered could not be found. Please check your details.',
      introText2:
        'Select the items you want to cancel or return and confirm your request below. Some items are excluded from return, such as configured or custom-made products.',
      orderHeading: 'Order {{orderNumber}}',
      orderDate: 'Order date:',
      selectAll: 'Select all',
      columnArticle: 'Article',
      columnQuantity: 'Quantity',
      columnUnitPrice: 'Unit price',
      columnTotalPrice: 'Price',
      confirmationLabel:
        'I confirm that I want to return the selected items from this order',
      contactNameLabel: 'Name of contact person',
      contactEmailLabel: 'Email address of contact person',
      contactEmailError: 'Please enter a valid email address.',
      submitButton: 'Cancel or Return',
      submitHint:
        'Once you click "Cancel & Return Items", we will send you a confirmation email that your request has been received.',
      notCancellableTitle: 'This order is excluded from cancellation',
      notCancellableIntro:
        'Certain items, such as configured or custom-made products, cannot be cancelled after the order has been placed. If you have any questions, please contact customer service.',
      notCancellableContactLink: 'Contact customer service',
      backToHome: 'Back to home',
    },
    productCard: {
      articleNumber: 'Article number: {{code}}',
      quantity: 'Quantity',
      net: 'Net',
      returnQuantityLabel: 'Quantity',
      returnQuantityError: 'You cannot return more items than were ordered.',
      reasonLabel: 'What is the reason for the return? (optional)',
      descriptionLabel: 'Description:',
      reason: {
        damageBefore: 'Damage before use',
        damageAfter: 'Damage after use',
        wrongItem: 'Wrong item delivered',
        wrongQuantity: 'Wrong quantity delivered',
        return: 'Return within goodwill period',
      },
      notCancellableText: 'This item is excluded from cancellation as it was individually manufactured.',
      notCancellableContactPrefix: 'If you have any questions about this restriction, please contact our ',
      notCancellableContactLink: 'customer service',
    },
    success: {
      title: 'Thank you. We have received your request.',
      backToHome: 'Back to home',
      returnSectionHeading: 'Return items',
      returnSectionText:
        'If you have already received your items, you can download a return label below. We will cover the return shipping costs.',
      dhlButton: 'Print DHL return label',
      postButton: 'Print Post return label',
    },
  },
  breadcrumb: {
    service: 'Service & Benefits',
    returns: 'Returns',
  },
  returns: {
    page: {
      title: 'Returns at Wehrfritz',
      bannerAlt: 'Returns at Wehrfritz',
      noLabelHeading: 'No return label at hand?',
      introText:
        'Would you like to send your shipment back to us? The easiest way is to use the original packaging.',
      infoHeading: 'Current information',
      infoDelay:
        'Processing returns is currently taking a little longer. Therefore, issuing credit notes and refunds also takes more time.',
      infoThanks: 'We kindly ask for your understanding and thank you for your patience!',
      tipsHeading: 'Notes for your return',
      tips: {
        freeReturn:
          'With the return label provided by us, the return shipment is free of charge for you.',
        exclusions:
          'Attention! The following products are made to order and are therefore excluded from exchange: furniture, upholstery, carpets, gym equipment, outdoor play equipment.',
        validity:
          'Please note: The return label is only valid for returns to HABA Sales GmbH & Co. KG in Bad Rodach.',
        sizeWeight: 'The maximum parcel size is 60 x 60 x 120 cm, the maximum weight is 30 kg.',
        importantLabel: 'Important:',
        importantDescription:
          'Please enclose the return slip with the completed return reasons with your return.',
        labelVisibility: 'Affix the return label prominently to the parcel before sending it.',
        receipt:
          'Please keep the proof of posting. It serves as evidence if the parcel is lost in transit.',
      },
      dropOffHeading: 'You can find a parcel drop-off point near you',
      dropOffDhlPrefix: 'for DHL:',
      dropOffPostPrefix: 'for Post AT:',
      contactFormIntro: 'If you need further assistance, please use the following form:',
      contactFormTitle: 'Contact form',
    },
    form: {
      description:
        'Simply print it here. Enter your order number in the field below and click submit.',
      orderNumberLabel: 'Order number',
      orderNumberPlaceholder: 'Order number',
      submit: 'Submit',
      submitAriaLabel: 'Submit return label form',
      invalidOrder: 'The order number entered is invalid or could not be found.',
      instructionsHeading: 'Create your own return label — it is that easy:',
      instructions: {
        selectCarrier: 'Choose your preferred carrier (DHL or Hermes).',
        openOnlineForm: 'The online return form will open.',
        enterData: 'Enter your data.',
        receiveLabel:
          'You will receive your return label by email and can print it immediately. Or simply save the QR code on your smartphone and show it in the parcel shop.',
      },
      links: {
        dhl: 'DHL return',
        hermes: 'Hermes return',
        returnAT: 'PRINT RETURN LABEL',
      },
    },
  },
};
